var EmailShareConfigurationService = (function () {
    function EmailShareConfigurationService($http) {
        this.$http = $http;
    }
    EmailShareConfigurationService.prototype.get = function () {
        var url = 'compatibilityguide/ng-settings/feature/forms/emailshare';
        return this.$http
            .get(url)
            .then(function (response) {
            return response.data;
        });
    };
    EmailShareConfigurationService.$inject = ['$http'];
    return EmailShareConfigurationService;
}());
export { EmailShareConfigurationService };
